import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'embedded-html',
    templateUrl: './embedded-html.component.html',
    styleUrls: ['./embedded-html.component.scss']
})
export class EmbeddedHtmlComponent {
    constructor(private domSanitizer: DomSanitizer) {}

    @Input() embeddedContent: string = null;
    @ViewChild('embedContainer') embedContainerEl: ElementRef;

    // Properties
    sanitizedHtml: SafeHtml

    ngOnInit() {
        this.sanitizedHtml = this.domSanitizer.bypassSecurityTrustHtml(this.embeddedContent);

        // Timeout allows a digest cycle to render the script tags on the page
        setTimeout(() => {
            let scripts = this.embedContainerEl.nativeElement.getElementsByTagName('script');
            for (let script of scripts) {
                eval(script.text);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/partials/embedded-html/embedded-html.component.ts